import { render, staticRenderFns } from "./Looks.vue?vue&type=template&id=5f8f67b2&"
import script from "./Looks.vue?vue&type=script&lang=js&"
export * from "./Looks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports